import { Component, Input, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatTableDataSource } from '@angular/material/table';

const DATATABLE = [
  {
    columnOne: 'Table row',
    columnTwo: 'Table row',
    columnThree: 'Table row',
    columnFour: 'Table row',
    isExpanded: false,
    subjects: [
      {
        name: 'Table row'
      }
    ]
  },
  {
    columnOne: 'Table row',
    columnTwo: 'Table row',
    columnThree: 'Table row',
    columnFour: 'Table row',
    isExpanded: false,
    subjects: [
      {
        name: 'Table row'
      }
    ]
  },
  {
    columnOne: 'Table row',
    columnTwo: 'Table row',
    columnThree: 'Table row',
    columnFour: 'Table row',
    isExpanded: false,
    subjects: [
      {
        name: 'Table row'
      }
    ]
  },
  {
    columnOne: 'Table row',
    columnTwo: 'Table row',
    columnThree: 'Table row',
    columnFour: 'Table row',
    isExpanded: false,
    subjects: [
      {
        name: 'Table row'
      }
    ]
  },
  {
    columnOne: 'Table row',
    columnTwo: 'Table row',
    columnThree: 'Table row',
    columnFour: 'Table row',
    isExpanded: false,
    subjects: [
      {
        name: 'Table row'
      }
    ]
  }
];


@Component({
  selector: 'ff-table-expand-collapse',
  templateUrl: './table-expand-collapse.component.html',
  styleUrls: ['./table-expand-collapse.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')), // Create the transition
    ]),
  ],
})
export class TableExpandCollapseComponent implements OnInit {

  isTableExpanded = false;

  dataList = new MatTableDataSource();
  displayedDataColumnsList: string[] = ['actions', 'columnOne', 'columnTwo', 'columnThree', 'columnFour'];

  ngOnInit() {
    this.dataList.data = DATATABLE;
  }

}
